import { Step } from "react-joyride";

export const imageFormSteps: Step[] = [
    {
        target: "body", // Target the entire page
        content:
            "Welcome to the CharGen Image Generator! Let me guide you through the features.",
        placement: "center",
        isFixed: true,
        disableBeacon: true, // Disable the initial dot
    },
    {
        target: ".joyride-model-selection",
        content:
            "Select the AI model you want to use. Different models offer various features and may have different costs. Lightning models offer faster speed but may trade off in quality. Different models are better for different artistic styles. Try them all out and find your favourite!",
    },
    {
        target: ".joyride-image-size",
        content:
            "Choose the size of the image you want to generate. Choose different widths or heights.",
    },
    {
        target: ".joyride-number-of-images",
        content:
            "Select the number of images to generate up to a maximum of 4. Note: Premium and Flux.Pro models are limited to 1 image per go.",
    },
    {
        target: ".joyride-tabs",
        content:
            "Switch between the Detailed Form and Manual Prompt to customize your image generation process. Manual Prompt offers a simpler text input if you already have a prompt you want to use, but it will miss out on internal prompt processing unlike the detailed form.",
    },
    {
        target: ".joyride-character-sheet-file",
        content:
            "Upload your character sheet PDF file (Like from D&D Beyond) to automatically fill in character details. Note, you cannot just rename a file from an image to a PDF as that will break. If you need help press the Help? button for information on how to generate one.",
    },
    {
        target: ".joyride-character-sheet-url",
        content:
            "Alternatively, enter the URL of your character sheet PDF to import character details.",
    },
    {
        target: ".joyride-art-style",
        content:
            "Select an art style from the list or enter your own to define the artistic style of the image. Eg. Realistic, Comic Book, Gothic Horror. Try it out now and find your favourite art style!",
    },
    {
        target: ".joyride-theme",
        content:
            "Choose a theme for your image or enter a custom theme to set the setting. There's a variety of pre-generated ones such as Medieval Towns, Dungeons, and so much more! Alternately create your own if you want something specific!",
    },
    {
        target: ".joyride-additional-info",
        content:
            "Provide any additional information to further customize your image, for example specific poses, full body shot, any mounts or pets with them. This is optional and limited to Premium Generations or Subscribers.",
    },
    {
        target: ".joyride-premium-toggle",
        content:
            "Toggle Premium Content to access an enhanced generation model with greater prompt adherence (Better at specifics such as complex Races, Hair Colour, etc.). This just means the model is better at processing very complicated prompts, try it out if you're not getting the results you want from regular models.",
    },
    {
        target: ".joyride-generate-button",
        content:
            "Click here to generate your image based on the settings you've selected.",
    },
    {
        target: ".joyride-save-preset",
        content:
            "Save your current settings as a preset for easy access in future sessions, this will even save character PDFs that you've entered so you don't have to keep reuploading! This is a subscriber only feature.",
    },
    {
        target: ".joyride-total-cost",
        content:
            "This shows the total cost in gold for generating the image with your current settings. You can get more gold by sharing your images, referring others, or subscription or one-off purchases.",
    },
];
